import React, { useCallback, useEffect, useMemo } from "react";
import { ResultsGrid } from "./ResultsGrid";
import { BaseDraggable } from "../BaseDraggable";
import { useStore } from "../../../stores/store";
import { DraggableKeys, ModalKeys } from "../../../interfaces/config";
import _ from "lodash";
import { ResultsToolbar } from "./ResultsToolbar";
import MobileResults from "./MobileResults";
const key = DraggableKeys.RESULTS_DRAGGABLE;

export default function ResultsDraggable() {
  const {
    isActive,
    toggleActiveItem,
    results,
    activeResultsType,
    config,
    activateTool,
    setDetailsSelection,
    isMobile,
  } = useStore();

  const [selectedParcel, setSelectedParcel] = React.useState(null);

  const getColumnsByTab = useMemo(() => {
    const columns =
      config?.resultsOptions?.columnLookup?.[activeResultsType] || [];
    console.log("Using columns for tab:", activeResultsType, columns);
    return _.cloneDeep(columns);
  }, [config, activeResultsType]);

  const gridData = React.useMemo(() => {
    if (!results || results.length === 0) {
      return [];
    }
    if (results[0]?.attributes.ZoningClassification) {
      const anyWithComma = results.some((row) => {
        return row.attributes.ZoningClassification?.includes(",");
      });
      if (anyWithComma) {
        activateTool(ModalKeys.ZONING_NOTIFICATION);
      }
    }
    return results.map((row) => {
      return {
        geometry: row.geometry,
        ...row.attributes,
      };
    });
  }, [results]);

  // useEffect(() => {
  //   if (gridData.length === 1) {
  //     setDetailsSelection(gridData[0]);
  //     toggleActiveItem(key);
  //   }
  // }, [gridData]);

  return (
    <BaseDraggable
      id={key}
      zIndex={4}
      onClose={() => {
        toggleActiveItem(key);
      }}
      onBack={selectedParcel ? () => setSelectedParcel(null) : undefined}
      visible={isActive(key)}
      initialPosition="bottom-left"
      headerText="RESULTS"
      size={results.length === 0 ? "lg" : "xl"}
      toolbar={() => (
        <>
          {!config?.resultsOptions?.disableToolbar && (
            <ResultsToolbar options={config?.toolbarOptions} data={gridData} />
          )}
        </>
      )}
    >
      {results.length === 0 ? (
        <div className="bg-red-200 text-red-500 border border-red-500 p-1 rounded-sm my-4">
          No results. Perform a search to view results.
        </div>
      ) : (
        <>
          {isMobile ? (
            <MobileResults
              gridData={gridData}
              setDetailsSelection={setDetailsSelection}
              toggleActiveItem={() => toggleActiveItem(key)}
              setSelectedParcel={setSelectedParcel}
              selectedParcel={selectedParcel}
            />
          ) : (
            <>
              {config?.resultsOptions?.title !== "" &&
              config?.resultsOptions?.title != null ? (
                <p className="text-xs text-bold m-0 p-0">
                  {config?.resultsOptions?.title}
                </p>
              ) : null}
              <ResultsGrid
                rows={gridData}
                columns={getColumnsByTab}
                isSelectable={config?.resultsOptions?.isSelectable}
                includePagination={config?.resultsOptions?.includePagination}
              />
            </>
          )}
        </>
      )}
    </BaseDraggable>
  );
}
